const ecommpayLink = document.createElement('link');
ecommpayLink.setAttribute('rel', 'stylesheet');
ecommpayLink.setAttribute('href', 'https://paymentpage.etoplatezhi.ru/shared/merchant.css');

const ecommpayScript = document.createElement('script');
ecommpayScript.setAttribute('src', 'https://paymentpage.etoplatezhi.ru/shared/merchant.js');

document.head.appendChild(ecommpayLink);
document.head.appendChild(ecommpayScript);
